/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChangeRequestContactRequest } from './ChangeRequestContactRequest';
import {
    ChangeRequestContactRequestFromJSON,
    ChangeRequestContactRequestFromJSONTyped,
    ChangeRequestContactRequestToJSON,
    ChangeRequestContactRequestToJSONTyped,
} from './ChangeRequestContactRequest';
import type { StoreProfileImagesRequest } from './StoreProfileImagesRequest';
import {
    StoreProfileImagesRequestFromJSON,
    StoreProfileImagesRequestFromJSONTyped,
    StoreProfileImagesRequestToJSON,
    StoreProfileImagesRequestToJSONTyped,
} from './StoreProfileImagesRequest';
import type { ChangeRequestOpeningHourRequest } from './ChangeRequestOpeningHourRequest';
import {
    ChangeRequestOpeningHourRequestFromJSON,
    ChangeRequestOpeningHourRequestFromJSONTyped,
    ChangeRequestOpeningHourRequestToJSON,
    ChangeRequestOpeningHourRequestToJSONTyped,
} from './ChangeRequestOpeningHourRequest';
import type { ChangeRequestAddressRequest } from './ChangeRequestAddressRequest';
import {
    ChangeRequestAddressRequestFromJSON,
    ChangeRequestAddressRequestFromJSONTyped,
    ChangeRequestAddressRequestToJSON,
    ChangeRequestAddressRequestToJSONTyped,
} from './ChangeRequestAddressRequest';

/**
 * 
 * @export
 * @interface ChangeRequestAndDraftRequest
 */
export interface ChangeRequestAndDraftRequest {
    /**
     * 
     * @type {ChangeRequestAndDraftRequestTypeEnum}
     * @memberof ChangeRequestAndDraftRequest
     */
    type: ChangeRequestAndDraftRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestAndDraftRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestAndDraftRequest
     */
    openingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestAndDraftRequest
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeRequestAndDraftRequest
     */
    wpnStore?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeRequestAndDraftRequest
     */
    otsStore?: boolean;
    /**
     * 
     * @type {ChangeRequestAddressRequest}
     * @memberof ChangeRequestAndDraftRequest
     */
    address?: ChangeRequestAddressRequest;
    /**
     * 
     * @type {ChangeRequestContactRequest}
     * @memberof ChangeRequestAndDraftRequest
     */
    contact?: ChangeRequestContactRequest;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChangeRequestAndDraftRequest
     */
    categories?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChangeRequestAndDraftRequest
     */
    accessibilities?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChangeRequestAndDraftRequest
     */
    equipments?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChangeRequestAndDraftRequest
     */
    paymentMethods?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChangeRequestAndDraftRequest
     */
    activities?: Array<string>;
    /**
     * 
     * @type {ChangeRequestOpeningHourRequest}
     * @memberof ChangeRequestAndDraftRequest
     */
    openingHours?: ChangeRequestOpeningHourRequest;
    /**
     * 
     * @type {StoreProfileImagesRequest}
     * @memberof ChangeRequestAndDraftRequest
     */
    images?: StoreProfileImagesRequest;
}


/**
 * @export
 */
export const ChangeRequestAndDraftRequestTypeEnum = {
    Online: 'ONLINE',
    Local: 'LOCAL'
} as const;
export type ChangeRequestAndDraftRequestTypeEnum = typeof ChangeRequestAndDraftRequestTypeEnum[keyof typeof ChangeRequestAndDraftRequestTypeEnum];


/**
 * Check if a given object implements the ChangeRequestAndDraftRequest interface.
 */
export function instanceOfChangeRequestAndDraftRequest(value: object): value is ChangeRequestAndDraftRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ChangeRequestAndDraftRequestFromJSON(json: any): ChangeRequestAndDraftRequest {
    return ChangeRequestAndDraftRequestFromJSONTyped(json, false);
}

export function ChangeRequestAndDraftRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeRequestAndDraftRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'name': json['name'] == null ? undefined : json['name'],
        'openingDate': json['openingDate'] == null ? undefined : json['openingDate'],
        'description': json['description'] == null ? undefined : json['description'],
        'wpnStore': json['wpnStore'] == null ? undefined : json['wpnStore'],
        'otsStore': json['otsStore'] == null ? undefined : json['otsStore'],
        'address': json['address'] == null ? undefined : ChangeRequestAddressRequestFromJSON(json['address']),
        'contact': json['contact'] == null ? undefined : ChangeRequestContactRequestFromJSON(json['contact']),
        'categories': json['categories'] == null ? undefined : json['categories'],
        'accessibilities': json['accessibilities'] == null ? undefined : json['accessibilities'],
        'equipments': json['equipments'] == null ? undefined : json['equipments'],
        'paymentMethods': json['paymentMethods'] == null ? undefined : json['paymentMethods'],
        'activities': json['activities'] == null ? undefined : json['activities'],
        'openingHours': json['openingHours'] == null ? undefined : ChangeRequestOpeningHourRequestFromJSON(json['openingHours']),
        'images': json['images'] == null ? undefined : StoreProfileImagesRequestFromJSON(json['images']),
    };
}

export function ChangeRequestAndDraftRequestToJSON(json: any): ChangeRequestAndDraftRequest {
    return ChangeRequestAndDraftRequestToJSONTyped(json, false);
}

export function ChangeRequestAndDraftRequestToJSONTyped(value?: ChangeRequestAndDraftRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'name': value['name'],
        'openingDate': value['openingDate'],
        'description': value['description'],
        'wpnStore': value['wpnStore'],
        'otsStore': value['otsStore'],
        'address': ChangeRequestAddressRequestToJSON(value['address']),
        'contact': ChangeRequestContactRequestToJSON(value['contact']),
        'categories': value['categories'],
        'accessibilities': value['accessibilities'],
        'equipments': value['equipments'],
        'paymentMethods': value['paymentMethods'],
        'activities': value['activities'],
        'openingHours': ChangeRequestOpeningHourRequestToJSON(value['openingHours']),
        'images': StoreProfileImagesRequestToJSON(value['images']),
    };
}

